import { Dropdown } from "react-bootstrap";
import { useTheme } from "../../../../../hooks/ThemeProvider";

export default function ActivityHeader() {
    const { theme } = useTheme();
  return (
    <>
      {/* <h3>My Activity</h3> */}
      <Dropdown>
        {/* <Dropdown.Toggle variant="success" id="dropdown-basic">
          Sort by <span>Date</span>
          <div>
             {
                theme === 'dark' ?   <img src="\assets\droparrow.svg" className="dropsvg" />
                  : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M3 4.5L6 7.5L9 4.5" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }


          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item>
            <div className="drop_inside">
              <h5>
                Sort by: <span>Name Ascending </span>
              </h5>
              <img src="\assets\bluetick.svg" />
            </div>
          </Dropdown.Item>
          <Dropdown.Item>
            <div className="drop_inside">
              <h5>
                Sort by: <span>Name Descending </span>
              </h5>
            </div>
          </Dropdown.Item>
          <Dropdown.Item>
            <div className="drop_inside">
              <h5>
                Sort by: <span>APR </span>
              </h5>
            </div>
          </Dropdown.Item>
          <Dropdown.Item>
            <div className="drop_inside">
              <h5>
                Sort by: <span>TVL </span>
              </h5>
            </div>
          </Dropdown.Item>
          <Dropdown.Item>
            <div className="drop_inside">
              <h5>
                Sort by: <span>Lock Options </span>
              </h5>
            </div>
          </Dropdown.Item>
        </Dropdown.Menu> */}
      </Dropdown> 
    </>
  );
}
